// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3-u-4","textarea":"styles_textarea__1E1yK"};